export default __webpack_public_path__ + "static/media/114.387e52b4.jpg";